import { useEffect, useState } from "react";
import "./titleSection.css";

const TitleSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 80);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="hero-section">
      <div className={`hero-container ${isVisible ? "hero-visible" : ""}`}>

        <p className="hero-eyebrow hero-eyebrow-lg">Khor Developer</p>

        <h1 className="hero-headline">
          Commercial real estate<br />
          cash flow modeling software,<br />
          <span className="hero-headline-accent">inside Excel</span>
        </h1>

        <p className="hero-subtext">
          For brokers, appraisers, and investment teams who want institutional-quality analysis without leaving their own Excel models.
        </p>

        <div className="hero-ctas">
          <a href="/contact?requestType=Demo" className="btn-hero-primary">
            Book a Demo
          </a>
        </div>

      </div>
    </section>
  );
};

export default TitleSection;
